function cov_274c1wpblb() {
  var path = "/app/src/components/snippet-wrapper/index.tsx";
  var hash = "53deb31e7ada5ad25711994b570908806912ba52";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-wrapper/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "53deb31e7ada5ad25711994b570908806912ba52"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_274c1wpblb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_274c1wpblb();
export { SnippetWrapper } from './snippet-wrapper';